import { useDataSource } from '@/features/data/DataSourceContext';
import { useListChatsQuery } from './api/chat.api';

export function useChatTitleResolver(): (chatId: string) => string | undefined {
  const { source } = useDataSource();
  const { data } = useListChatsQuery({ source, params: undefined });
  return (chatId) => data?.chats.find((chat) => chat.id === chatId)?.title;
}
